export default __webpack_public_path__ + "static/media/copypaste.e5baf4e0.svg";